import { addDays, addMinutes, addMonths, parseISO } from "date-fns";
import { HistoricalDataItemGroup } from "../../services/historicalData";
import { TChartItem } from "./types";

export function mapHistoryGroupItemsToChartItems(data: HistoricalDataItemGroup[], offset: number): TChartItem[] {
  const timezoneOffset = (new Date()).getTimezoneOffset(); // timezones like Bogota -5 aree wrong without the correction
  return data.map((item: HistoricalDataItemGroup) => {
    return { x: addMinutes(addDays(parseISO(item.timeStamp), offset), timezoneOffset), y: item.sumValue }
  });
}

export function mapHistoryGroupItemsToChartItemsMonth(data: HistoricalDataItemGroup[], offset: number): TChartItem[] {
  const timezoneOffset = (new Date()).getTimezoneOffset(); // timezones like Bogota -5 aree wrong without the correction
  return data.map((item: HistoricalDataItemGroup) => {
    return { x: addMinutes(addMonths(parseISO(item.timeStamp), offset), timezoneOffset), y: item.sumValue }
  });
}